import React from 'react';

import { IPlanInfoFields } from '../../../types/contentful';

import RichText from '../RichText';

import {
  Logo,
  PlanInfoWrapper,
  TextWrapper,
  LogoWrapper,
  ButtonWrapper
} from './styles';

// TODO: when fonts are correct, check bolded weight
export function PlanInfo({ color, logo, copy, button }: IPlanInfoFields) {
  const { file, description } = logo?.fields ?? {};

  return (
    <PlanInfoWrapper data-testid="plans-info">
      {file && (
        <LogoWrapper color={color ?? ''}>
          <Logo src={`https:${file?.url}`} alt={description} />
        </LogoWrapper>
      )}
      <TextWrapper>
        {copy && (
          <div>
            <RichText data={copy} />
          </div>
        )}
        {button && (
          <ButtonWrapper>
            <RichText data={button} />
          </ButtonWrapper>
        )}
      </TextWrapper>
    </PlanInfoWrapper>
  );
}
